import {
  List,
  Datagrid,
  ReferenceField,
  TextField,
  NumberField,
  UrlField,
  SearchInput,
  ReferenceInput,
  TextInput,
  NumberInput,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  Create,
  Show,
  SimpleShowLayout,
  BooleanInput,
  BooleanField,
} from 'react-admin'
import { useWatch, useFormContext } from 'react-hook-form'
import { useEffect } from 'react'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const TokenList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <ReferenceInput source="networkId" reference="networks" />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <ReferenceField source="networkId" reference="networks" />
      <TextField source="name" />
      <TextField source="symbol" />
      <TextField source="contractAddress" />
      <NumberField source="decimals" />
      <NumberField source="price" />
      <TextField source="currency" />
      <TextField source="identifier" />
      <UrlField source="iconUrl" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const TokenEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="symbol" />
      <NumberInput source="decimals" />
      <TextInput source="contractAddress" />
      <BooleanInput source="isManualPrice" />
      <ConditionalPriceFields />
      <TextInput source="iconUrl" type="url" />
    </SimpleForm>
  </Edit>
)

const ConditionalPriceFields = () => {
  const { setValue } = useFormContext()
  const isManualPrice = useWatch({ name: 'isManualPrice' })

  useEffect(() => {
    if (isManualPrice) {
      setValue('identifier', undefined)
    } else {
      setValue('price', undefined)
    }
  }, [isManualPrice, setValue])

  if (isManualPrice) {
    return <NumberInput source="price" required />
  }

  return <TextInput source="identifier" required />
}

export const TokenCreate = () => {
  const transform = (data) => {
    const transformedData = { ...data }
    if (transformedData.isManualPrice) {
      delete transformedData.identifier
    } else {
      delete transformedData.price
    }
    return transformedData
  }

  return (
    <Create>
      <SimpleForm transform={transform}>
        <ReferenceInput source="networkId" reference="networks" required />
        <TextInput source="name" required />
        <TextInput source="symbol" required />
        <TextInput source="contractAddress" required />
        <NumberInput source="decimals" required />
        <BooleanInput source="isManualPrice" />
        <ConditionalPriceFields />
        <TextInput source="iconUrl" type="url" />
      </SimpleForm>
    </Create>
  )
}

export const TokenShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="networkId" reference="networks" />
      <TextField source="name" />
      <TextField source="symbol" />
      <TextField source="contractAddress" />
      <NumberField source="decimals" />
      <NumberField source="price" />
      <TextField source="currency" />
      <TextField source="identifier" />
      <NumberField source="price" />
      <BooleanField source="isManualPrice" />
      <UrlField source="iconUrl" />
    </SimpleShowLayout>
  </Show>
)
